import { useMemo } from 'react';

import { AgGridTable } from 'core/components';
import { SortDirection, TableLayoutType } from 'core/enums';
import { AgGridClientTableProvider } from 'core/states';
import { useGetElementTemplates } from 'elements/hooks';

import { RemoveElementTemplatesButton, UpsertElementTemplateButton } from './actions';
import { columnDef } from './columns';
import { DetailElementTemplate } from './DetailElementTemplate';
import { ElementTemplateListColId } from './enums';

export const ElementTemplateList = () => {
  const { records, isLoading, loadingPercentage } = useGetElementTemplates();

  const columnDefs = useMemo(() => columnDef(), []);

  const initialState = useMemo(
    () => ({
      sort: {
        sortModel: [{ colId: ElementTemplateListColId.UPDATED_AT, sort: SortDirection.DESC }],
      },
    }),
    []
  );

  const actionButtons = useMemo(
    () => [<UpsertElementTemplateButton key="upsertElementTemplateButton" />],
    []
  );

  const selectionActionButtons = useMemo(
    () => [<RemoveElementTemplatesButton key="removeElementTemplatesButton" />],
    []
  );

  return (
    <AgGridClientTableProvider
      tableId="elementTemplateList"
      entityType="ElementTemplate"
      initialState={initialState}
      columnDefs={columnDefs}
      data={records}
      isDataLoading={isLoading}
      loadingPercentage={loadingPercentage}
      layoutType={TableLayoutType.ELEMENT_TEMPLATE}
      hasLayoutActions
      headerCheckbox
      masterDetail
      detailRowAutoHeight
      detailCellRenderer={DetailElementTemplate}
      isRowMaster={() => true}
    >
      <AgGridTable actionButtons={actionButtons} selectionActionButtons={selectionActionButtons} />
    </AgGridClientTableProvider>
  );
};
